import { createContext } from 'react';

export const initialState = {
  pageTitle: '',
  navContents: {
    logo: [],
    logoMobile: [],
    description: '',
    expandedCopy: '',
    navigationItems: []
  },
  navMenuBackground: 'black',
  navMenuHidden: false,
  navPagination: null,
  articleCards: [],
  articleCategory: null,
  articlePostdate: null,
  isArticleCardsLoaded: false,
  homepagePosters: [],
  homePagePosterQueryVars: { offset: 0, limit: 1 },
  homepageHeaderOffset: 0,
  isTransported: false,
  categoryFilter: '',
  previousArticleFocus: ''
};

const decodeGlobalContext = createContext(initialState);

export default decodeGlobalContext;
